import React, { useEffect, useState } from "react";
import { FaqSectionStyle } from "./style";
import usehook from "./usehook";

const FaqSection = () => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const { getAllFaqs } = usehook();
  const fetchedData = async () => {
    try {
      const res = await getAllFaqs();
      setFaqs(res);
    } catch (error) {}
  };

  useEffect(() => {
    fetchedData();
  }, []);

  const handleAccordionToggle = (index) => {
    setOpenAccordion((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <FaqSectionStyle>
      {/* FAQ-Section start */}
      <section className="row_am faq_section" id="faqs">
        {/* container start */}
        <div className="container">
          <div
            className="section_title"
            data-aos="fade-up"
            data-aos-duration={1500}
            data-aos-delay={300}
          >
            {/* h2 */}
            <h2>
              <span>FAQ</span> - Frequently Asked Questions
            </h2>
            {/* p */}
            <p>
              Find answers to common queries about Riva's features,
              subscription <br /> plans, and more. Our FAQ section provides
              clear and concise <br /> information to help you make the most of
              your experience.
            </p>
          </div>
          {/* faq data */}
          <div className="faq_panel">
            <div className="accordion" id="accordionExample">
              {faqs?.length > 0 ? (
                faqs.map((item, index) => (
                  <div
                    className="card"
                    data-aos="fade-up"
                    data-aos-duration={1500}
                    key={index}
                  >
                    <div className="card-header" id={`heading${item.id}`}>
                      <h2 className="mb-0">
                        {item?.question !== undefined ? (
                          <button
                            type="button"
                            className={`btn btn-link ${
                              openAccordion === index ? "" : "collapsed"
                            }`}
                            onClick={() => handleAccordionToggle(index)}
                          >
                            <i
                              className={`icon_faq ${
                                openAccordion === index
                                  ? "icofont-minus"
                                  : "icofont-plus"
                              }`}
                            />
                            {item.question}
                          </button>
                        ) : (
                          <p className="text-center text-danger">
                            No Question Found
                          </p>
                        )}
                      </h2>
                    </div>
                    <div
                      id={`collapse${item.id}`}
                      className={`collapse ${
                        openAccordion === index ? "show" : ""
                      }`}
                      aria-labelledby={`heading${item.id}`}
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        {item?.answer !== undefined ? (
                          <p className="text-clr">{item.answer}</p>
                        ) : (
                          <p className="text-center text-danger">
                            No Answer Found
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center text-danger">No Record Found</div>
              )}
            </div>
          </div>
        </div>
        {/* container end */}
      </section>
      {/* FAQ-Section end */}
    </FaqSectionStyle>
  );
};

export default FaqSection;
